import BiometricUserTable from "../features/biometric-user/components/biometric-user-table";
import { useAppSelector } from "../app/hooks";
import useMembers from "../hooks/use-members";
import * as BiometricDeviceSlice from "../features/biometric-device/biometric-device.slice";
import Loader from "../components/loader";
import useBiometricUsers from "../hooks/use-biometric-users";
import { useParams } from "react-router";
import useUsers from "../hooks/use-users";

const BiometricUsers = () => {
    // const dispatch = useAppDispatch();
    // const [showBiometricDeviceForm, setShowBiometricDeviceForm] = useState(false);
    const { deviceId } = useParams<{ deviceId: string }>();
    const isLoading = useAppSelector(BiometricDeviceSlice.selectIsLoading);

    const [biometricUsers] = useBiometricUsers(deviceId ? Number(deviceId) : undefined);
    const [members] = useMembers();
    const [users] = useUsers();

    // const handleSubmit = (data: BiometricDeviceRequest) => {
    //     dispatch(BiometricDeviceSlice.createBiometricDevice(data)).then(resp => {
    //         if (resp.meta.requestStatus === 'fulfilled') {
    //             setShowBiometricDeviceForm(false);
    //         }
    //     }).catch(err => {
    //         console.error(err);
    //     });
    // };

    return (
        <div>
            {isLoading &&
                <Loader />
            }
            {biometricUsers &&
                <>
                    {/* <Box sx={{ mb: "12px" }}>
                        <CreateButton variant="contained" onClick={() => setShowBiometricDeviceForm(true)} style={{ marginBottom: "12px" }}>Add Device</CreateButton>
                    </Box> */}
                    <BiometricUserTable users={biometricUsers} deviceId={Number(deviceId)} />
                    {/* {showBiometricDeviceForm &&
                        <BiometricDeviceForm device={undefined} editable={true} onClose={() => setShowBiometricDeviceForm(false)} onSubmit={handleSubmit} />
                    } */}
                </>
            }
        </div>
    )
}

export default BiometricUsers;